// extracted by mini-css-extract-plugin
module.exports = {"close":"components-TasteInfo-TasteInfo__close--3FCaC"};